import React, {PropTypes} from 'react';

const RecipeCover = ({recipe, className, zIndex, thisIndex}) => {				
	let coverImage = require('../../images/covers/cover_' + recipe.id + '.jpg');
	//console.log(zIndex);
	return(
		<div className={className} style={{zIndex:`${zIndex}`, backgroundImage: `url(${coverImage})`}} data-id={recipe.id} data-name={recipe.title} data-index={thisIndex}>
		<p>{recipe.title}</p></div>
	);
};

RecipeCover.propTypes = {
	recipe: PropTypes.object.isRequired,
	className: PropTypes.string,
	zIndex: PropTypes.number,
	thisIndex: PropTypes.number
};

export default RecipeCover;


/** WEBPACK FOOTER **
 ** ./src/components/recipes/RecipeCover.js
 **/